package fyi.moko.hotpl.ui.changelog

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import fyi.moko.hotpl.domain.model.Changelog
import fyi.moko.hotpl.domain.model.ChangelogEntry
import fyi.moko.hotpl.domain.service.ChangelogStore
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

class ChangelogViewModel(
    private val changelogStore: ChangelogStore,
) : ViewModel() {

    val entries: List<ChangelogEntry> = Changelog.entries

    /** Drives the "there is something new" cue on Home until the list is opened. */
    val hasUnseen: StateFlow<Boolean> = changelogStore.lastSeenVersion
        .map { Changelog.hasUnseen(it) }
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5_000),
            initialValue = false,
        )

    /**
     * Called when the reader actually opens the list. Opening is the whole signal — an alpha
     * tester who has the changes on screen has been told, and asking them to also tick
     * something would just be a second thing to miss.
     */
    fun markSeen() {
        val newest = Changelog.latest ?: return
        viewModelScope.launch { changelogStore.markSeen(newest.version) }
    }
}
